module.exports = __webpack_public_path__ + "img/5.ba253c5c.png";